import FlagCookie from './Plaintext.FlagCookie.js';
import FocusManagement from './FocusManagement.js';

let ageGateFlag = new Plaintext.FlagCookie("gbsc-ageGate", { expiryDays: 30 });

function init() {
  const ageGateHasBeenShown = ageGateFlag.isSet();
    
  if (!ageGateHasBeenShown || window.location.hash === '#age-gate') {
    showAgeGate();
  }
}

function showAgeGate() {
  const ageGateWrap = document.querySelector('.ageGate__wrap');
  ageGateWrap.classList.add('ageGate__wrap--enabled');
  
  const yesButton = ageGateWrap.querySelector('.ageGate__yes');
  const noButton = ageGateWrap.querySelector('.ageGate__no');
  
  FocusManagement.enableFocusTrap(ageGateWrap);
  
  yesButton.addEventListener('click', () => {
    ageGateFlag.set();
    closeAgeGate();
  });
  noButton.addEventListener('click', () => {
    ageGateWrap.classList.add('ageGate__wrap--tooYoung');
  });
  
  document.body.classList.add('ageGateOpen');
}

function closeAgeGate() {
  const ageGateWrap = document.querySelector('.ageGate__wrap');
  FocusManagement.disableFocusTrap(ageGateWrap);
  ageGateWrap.classList.remove('ageGate__wrap--enabled');
  document.body.classList.remove('ageGateOpen');
}

const ageGate = { init };
export default ageGate;